// extracted by mini-css-extract-plugin
module.exports = {"annotationBox":"style-module__annotationBox___1SsQI","active":"style-module__active___3xmSp","numberLabel":"style-module__numberLabel___11Eoy"};